<template>
  <div>
    <v-autocomplete
      v-model="selectedOperators"
      :items="operators"
      item-text="fullname"
      :item-value="itemValue"
      :filled="filled"
      :label="label"
      :hide-details="hideDetails"
      :placeholder="placeholder"
      :dense="dense"
      :solo-inverted="soloInverted"
      :solo="solo"
      :flat="flat"
      :chips="chips"
      rounded
      :small-chips="smallChips"
      :multiple="multiple"
      :clearable="clearable"
      :loading="loading"
      :return-object="returnObject"
      :prepend-icon="prependIcon"
      :rules="rules"
      :error="error"
      :disabled="disabled"
      :readonly="readonly"
      ref="autocomplete"
      :search-input.sync="search"
      @change="search = null"
    >
      <template slot="append-outer">
        <slot name="append-outer"></slot>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import operatorManagment from "@/services/operators/operators.service.js";
import Vue from 'vue'

export default {
  name: "OperatorsAutocomplete",
  data: function() {
    let selection;
    if(!!this.value) {
      if(this.multiple && !this.returnObject) {
        selection = []
        for(let i = 0; i < this.value.length; i++) {
          selection.push(this.value[i])
        }
      } else if(!this.returnObject) {
        selection = this.value
      } else {
        selection = this.value
      }
    }

    return {
      operators: [],
      selectedOperators: selection,
      loading: false,
      search: null
    }
  },
  props: {
    value: {
      default: function() {
        return []
      }
    },
    bus: {
      type: Object,
      default: () => { new Vue() }
    },
    placeholder: {
      type: String,
      default: 'Tutti gli operatori'
    },
    dense: {
      type: Boolean,
      default: false
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    label: {
      type: String,
      default: 'Operatori'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      default: 'auto'
    },
    prependIcon: {
      type: String,
      default: 'mdi-account-hard-hat'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: true
    },
    solo: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    smallChips: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.loadOperators()

    if(!!this.bus) {
      this.bus.$on('reload', () => {
        this.loadOperators()
      })
      this.bus.$on('focus', () => {
        this.$nextTick(() => {
          this.$refs.autocomplete.focus()
        })
      })
    }
  },
  methods: {
    loadOperators() {
      this.loading = true
      
      if (!!this.filters.calendar) {
        if (!!this.filters.calendar.id && this.filters.calendar.id.length == 0) {
          delete this.filters.calendar
        }

        if (!!this.filters.calendar.name && this.filters.calendar.name.length == 0) {
          delete this.filters.calendar
        }
      }

      operatorManagment.cachedList({filters: this.filters}).then((operators) => {
        this.operators = operators
        this.loading = false
      })
    },
    arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
  },
  watch: {
    value(newVal) {
      this.selectedOperators = newVal
    },
    filters() {
      this.loadOperators()
    },
    selectedOperators(newVal) {
      if(this.multiple && !this.arraysEqual(newVal, this.value)) {
        this.$emit('input', newVal)
      } else if(!this.multiple && newVal != this.value) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>

<style>

</style>